export const textArray = ["The ultimate ZeroRanger arrange album.", "Enjoy nearly 3.5 hours of arrangements from System Erasure's iconic OST to ZeroRanger by eebrozgi!",
    "Journey through the cycle of ZeroRanger with 48 tracks, arranged by 44 incredible ZeroArrangers, featuring live performances from several musicians and vocalists.",
    "2025 Game Music Remix Award “Best Album” Winner!"
  ]
  
export const reviewsArray = [
    "“it scared me it was so good. every track is special and so transformative in the best way”",
    "“a masterclass collection of amazing artists making an all-timer VGM celebration of an indie classic. absolutely not to be missed, this could be the album of the year.”",
    "“The amount of raw talent on this album is so insane that I started using Bandcamp just to get this album and am using it as a reference for what artists to look for if I'm interested in more music. 10/10 no notes”",
    "“What can I even say... I am blown away by the utter artistry and care showcased in this project. What an amazing display of creativity and dedication.”",
    "“How can one album contain so much concentrated fire? May you attain enlightenment.”"
  ]


export const imageArray = ["Days.jpg", "Falcafe.jpg", "FBR1.jpg", "FBR2.jpg", "FBR3.jpg", "GuruGuru.jpg", "PAW1.jpg", "PAW2.jpg", "Resaga.jpg", "ZeroRanger.png"]
